import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import _ from 'lodash'
import dayjs from 'dayjs'

import i18n from 'i18next'

import supplierActions from '../../redux/suppliers/actions'

import PurchaseOrderStatusSwitches from '../../components/PurchaseOrderStatusSwitches'

const {
    saveSupplierOrders
} = supplierActions

class PurchaseOrderStatusSwitchesContainer extends Component {
    static propTypes = {
        // Props from another component
        supplierOrder: PropTypes.object.isRequired,

        // Inner Props
        saveSupplierOrders: PropTypes.func.isRequired,
        suppliers: ImmutablePropTypes.map.isRequired
    }

    static defaultProps = {
        // Object's keys are used
        supplierOrder: {
            id: '',
            order: '', // OSH...
            is_po_completed: false,
            is_checked: false,
            is_checked_history: {
                staff: {
                    first_name: '',
                    last_name: ''
                }
            },
            is_po_sent_to_supplier: false,
            state: '',
            transfer_date: undefined
        }
    }

    constructor (props) {
        super(props)

        dayjs.locale(i18n.language)

        const transferDate = _.get(props, 'supplierOrder.transfer_date', undefined)

        this.state = {
            creditDurationDays: 0,
            // transfer_date of supplier order is date_of_purchase of pv
            dateOfPurchase: (transferDate && dayjs(transferDate, 'YYYY-MM-DD')) || dayjs(new Date()),
            visibleCreditModal: false
        }
    }

    onCreditDurationDaysChange = (days) => {
        this.setState({ creditDurationDays: _.toNumber(days) || 0 })
    }

    onSwitchChange = (supplierOrderParams) => {
        const { saveSupplierOrders, supplierOrder } = this.props
        const orderId = _.get(supplierOrder, 'order', '')
        const id = _.get(supplierOrder, 'id', '')

        saveSupplierOrders({
            orderId,
            supplierOrder: supplierOrderParams,
            id,
            bankAccount: null
        })
    }

    onSubmitCreditForm = (supplierOrderParams, paymentVoucherParams) => {
        const { saveSupplierOrders, supplierOrder } = this.props
        const orderId = _.get(supplierOrder, 'order', '')
        const id = _.get(supplierOrder, 'id', '')

        saveSupplierOrders({
            orderId,
            supplierOrder: supplierOrderParams,
            id,
            paymentVoucher: paymentVoucherParams,
            onSuccess: () => {
                this.setState({ visibleCreditModal: false })
            }
        })
    }

    onToggleVisibleCreditModal = () => {
        const { visibleCreditModal } = this.state

        this.setState({ visibleCreditModal: !visibleCreditModal })
    }

    onDateOfPurchaseChange = (dateOfPurchaseMoment) => {
        this.setState({ dateOfPurchase: dateOfPurchaseMoment })
    }

    render () {
        const { suppliers, supplierOrder, showReceiptWarning } = this.props
        const {
            creditDurationDays,
            dateOfPurchase,
            visibleCreditModal
        } = this.state

        return (
            <PurchaseOrderStatusSwitches
                creditDurationDays={creditDurationDays}
                dateOfPurchase={dateOfPurchase}
                loading={suppliers.get('saving', false)}
                onCreditDurationDaysChange={this.onCreditDurationDaysChange}
                onDateOfPurchaseChange={this.onDateOfPurchaseChange}
                onSubmitCreditForm={this.onSubmitCreditForm}
                onSwitchChange={this.onSwitchChange}
                onToggleVisibleCreditModal={this.onToggleVisibleCreditModal}
                supplierOrder={supplierOrder}
                showReceiptWarning={showReceiptWarning}
                visibleCreditModal={visibleCreditModal}
            />
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const orderNumber = _.get(ownProps, 'supplierOrder.order', '')
    const orderEntity = state.getIn(['Entities', 'orders', orderNumber])

    let showReceiptWarning = false
    if (orderEntity) {
        const receipt = (orderEntity.get('sum_of_receipt') || 0) / 100.00
        const grandTotal = orderEntity.get('grand_total') || 0
        showReceiptWarning = receipt < grandTotal
    }

    return {
        suppliers: state.get('suppliers'),
        showReceiptWarning
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        saveSupplierOrders
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderStatusSwitchesContainer)
